module.exports = __webpack_public_path__ + "static/media/iv_badge_pending.a2b3d7c0.svg";